import React from 'react';
import { IconButton, Dialog, DialogTitle, Grid } from '@material-ui/core';
import useStyles from './Modal.style';
import { EmptyVoidFunction } from '../../utils/types/Types';
import closeModal from '../../assets/icons/closeModal.svg';

const defaultProps = {
  onClose: () => {},
  className: '',
  modalClassName: '',
  disableEnforceFocus: false,
  headerClassName: '',
};

export default function Modal(props: {
  children: JSX.Element;
  header: string;
  className?: string;
  modalClassName?: string;
  onClose?: EmptyVoidFunction;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  disableEnforceFocus?: boolean;
  headerClassName?: string;
}) {
  const { children, header, className, onClose, open, setOpen, modalClassName, disableEnforceFocus, headerClassName } =
    props;

  const styles = useStyles();

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={modalClassName || styles.modal}
      disableEnforceFocus={disableEnforceFocus}
    >
      <Grid container direction="row" className={className}>
        <DialogTitle className={headerClassName}>{header}</DialogTitle>
        <IconButton disableRipple aria-label="close" className={styles.closeButton} onClick={handleClose}>
          <img src={closeModal} alt="close" />
        </IconButton>
      </Grid>
      {React.cloneElement(children, {
        handleClose,
      })}
    </Dialog>
  );
}

Modal.defaultProps = defaultProps;
